import React from "react";
import "./Button.scss";
import { IFormElement } from "../../../types/IFormElement";

export default function Button({
     id, className, children, onClick, }:
      IFormElement & {}) {
        const buttonClass = `button ${className}`;
    return <button id={id} className={buttonClass} onClick={onClick}>{children}</button>;
}